<template>
  <w-radio-list :values="yesNoNot" :title="title" :model="model" :tooltip="tooltip" :disabled="checkDisabled()" />
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { YES_NO_NOT } from '@/utils/constants';

// @vuese
// komponent do opcji tak lub nie
// @Group detailsComponents
export default {
  mixins: [componentMixin],
  props: {
    // Przekazuje tooltip
    tooltip: { type: String, required: false }
  },
  data() {
    return {
      yesNoNot: YES_NO_NOT
    };
  }
};
</script>
